import { Spinner } from '@components/Spinner';
import { livePreviewUpdatingPillClasses } from '@features/live-pdf-preview/components/classes';
import clsx from 'clsx';

export const LoadingIndicator = () => {
  return (
    <div className={clsx(livePreviewUpdatingPillClasses)}>
      <span className="text-xs leading-4 font-medium">Loading</span>
      <Spinner
        className="[&>*:first-child]:fill-gray-300! [&>*:first-child]:opacity-100! [&>path]:fill-blue-600!"
        size="xs"
      />
    </div>
  );
};
